import { LinkButton } from '@cian/ui-kit';

import { type FC } from 'react';

import { type SeriaPlusScheme } from 'shared/settings/seriaPlusScheme';

import { LayoutBlock } from '../LayoutBlock';

import { Carousel } from './internal/components/Carousel';

import styles from './SeriaPlus.css';

type SeriaPlusProps = {
  scheme: SeriaPlusScheme;
};

export const SeriaPlus: FC<SeriaPlusProps> = props => {
  const {
    scheme: { media, disclaimer, description, title, blockTitle, watchObjectsLink },
  } = props;

  return (
    <LayoutBlock
      backgroundTheme="black"
      bottomOffset={60}
      id="seria-plus"
      rightAdornment={
        <div className={styles['right-adornment']}>
          <span className={styles['disclaimer']} data-testid="seria-plus-disclaimer">
            {disclaimer}
          </span>
          <div className={styles['description']} data-testid="seria-plus-description">
            {description.map((item, index) => (
              <span key={index}>{item}</span>
            ))}
          </div>
        </div>
      }
      sectionTabTitle={blockTitle}
      title={title}
      topOffset={60}
    >
      <div className={styles['container']} data-testid="seria-plus-carousel-container">
        <div className={styles['content']} data-testid="seria-plus-carousel-content">
          <div className={styles['carousel-wrapper']} data-testid="seria-plus-carousel-wrapper">
            <Carousel media={media} />
          </div>
          <div className={styles['link-button-container']} data-testid="seria-plus-carousel-link-button-container">
            <LinkButton
              fullWidth
              data-testid="seria-plus-carousel-link-button"
              href={watchObjectsLink}
              size="M"
              target="_blank"
              theme="stroke_secondary"
            >
              Смотреть проекты серии
            </LinkButton>
          </div>
        </div>
      </div>
    </LayoutBlock>
  );
};
